module.exports = __webpack_public_path__ + "static/media/borrower-info.73f04770.svg";